import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { ForecastItemProps } from 'components/forecast/forecastItem/forecastItemTypes';
import RoundedContainer from 'components/baseElements/roundedContainer';
import { DEFAULT_ELEVATION } from 'assets/theme';
import { getScoreThemeColor } from 'helpers/utils';
import { DateTypeStringHelper } from 'helpers/dateTimeStringHelper';

export default function ForecastItemDesktop({ dt, score }: ForecastItemProps) {
  const theme = useTheme();

  const dtHelper = new DateTypeStringHelper(dt);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
    >
      <RoundedContainer
        roundSide="left"
        sx={{
          bgcolor: getScoreThemeColor(score),
        }}
      >
        <Typography sx={{ color: 'custom.scoreDigit' }} variant="f26">
          {score}
        </Typography>
      </RoundedContainer>

      <RoundedContainer
        roundSide="right"
        sx={{
          background:
            // @ts-ignore
            theme.palette.customBackgrounds[
              `elevation${DEFAULT_ELEVATION + 1}`
            ],
        }}
      >
        <Typography sx={{ color: 'text.secondary' }} variant="f10">
          {dtHelper.dateTime.time}
        </Typography>
      </RoundedContainer>
    </Box>
  );
}
